export class UpcomingEventReservationsModelDTO {
  constructor (
    public venueId: string,
    public dateFrom?: string,
    public dateTo?: string,
    public pageSize?: number,
    public pageNumber?: number,
  ) {}
}
